export default "__VITE_PUBLIC_ASSET__4e8c878f__"